import { CardTypes } from "@/types/enums";
import { DownloadBlock } from "./DownloadBlock";

interface DownloadItem {
  name: string;
  url: string;
}

interface DownloadBlockProperties {
  title: string;
  downloadDescription?: string;
  downloads: DownloadItem[];
}

export default function DownloadBlockFactory(data: ContentBlock, key: number) {
  const content = data.content?.properties as
    | DownloadBlockProperties
    | undefined;

  if (!content) {
    return null;
  }

  const items = content.downloads.map((item) => ({
    cardType: CardTypes.Default,
    title: item.name,
    link: {
      url: item.url,
    },
  }));

  return (
    <DownloadBlock
      key={key}
      items={items}
      title={content.title}
      description={content.downloadDescription}
    />
  );
}
